import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorInfoTextComponent } from './error-info-text.component';

@NgModule({
  declarations: [ErrorInfoTextComponent],
  imports: [CommonModule],
  exports: [ErrorInfoTextComponent]
})
export class ErrorInfoTextModule {}
